/**
 * Display Preferences Settings Page
 * Calendar display options: visible hours, zoom level, and canceled-appointment visibility.
 */

import { createFileRoute, useParams } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SettingsPageHeader } from '@/components/ui'
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell'
import { CanceledVisibilityCard } from './calendar-appointments/components/canceled-visibility-card'
import { VisibleHoursCard } from './calendar-appointments/components/visible-hours-card'
import { ZoomLevelCard } from './calendar-appointments/components/zoom-level-card'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute('/_auth/$orgId/settings/calendar-appointments/display-preferences')({
  component: DisplayPreferencesPage,
})

function DisplayPreferencesPage() {
  const { orgId } = useParams({
    from: '/_auth/$orgId/settings/calendar-appointments/display-preferences',
  })

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Display Preferences', 'Calendar & Appointments')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="display-preferences">
        <SettingsPageHeader
          title="Display Preferences"
          description="Control how appointments appear on your calendar."
        />

        <div className="space-y-6 max-w-2xl">
          <VisibleHoursCard />
          <ZoomLevelCard />
          <CanceledVisibilityCard />
        </div>
      </BusinessSetupPageShell>
    </>
  )
}
